import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import type { Ga4Metrics, GscMetrics } from '@marketing-hub/shared';
import { kpiRangeForDays } from '@/features/dashboard/kpiRollup';
import { useProjectContext } from '@/project/ProjectContext';

export type GoogleDashboardResponse = {
  ga4: { snapshots: { snapshot_date: string; metrics: Ga4Metrics }[] };
  gsc: { snapshots: { snapshot_date: string; metrics: GscMetrics }[] };
};

export function useGoogleDashboard(days = 30, opts?: { enabled?: boolean }) {
  const { selectedProjectId } = useProjectContext();
  const { from, to } = kpiRangeForDays(days);
  const qs = new URLSearchParams({ from, to });
  if (selectedProjectId) qs.set('project_id', selectedProjectId);

  return useQuery({
    queryKey: ['dashboard', 'google', selectedProjectId ?? 'all', from, to],
    enabled: opts?.enabled !== false,
    queryFn: () => apiFetch<GoogleDashboardResponse>(`/api/dashboard/google?${qs.toString()}`),
  });
}
